import { useCallback, useMemo } from 'react';
import { Button, Box, Flex, Stack } from '@chakra-ui/react';
import { Trans } from '@lingui/react/macro';
import { AddIcon } from '@chakra-ui/icons';

import { EditorMode } from '@duke-hq/shared-constants/assessments';

import { unitAssessmentState } from '../../UnitAssessmentState';
import type { UnitAssessmentSlides } from '../../types';
import { FormSectionAccordion } from './FormSectionAccordion';

type FormSlidePropTypes = {
  slide: UnitAssessmentSlides[0];
};

export function FormSlide({ slide }: FormSlidePropTypes) {
  const sections = useMemo(() => ('sections' in slide ? (slide.sections ?? []) : []), [slide]);

  const handleAddSection = useCallback(() => {
    unitAssessmentState.setCurrentSlide(slide);
    unitAssessmentState.setEditorType('FORM_SECTION');
    unitAssessmentState.setEditorMode(EditorMode.CREATE);
    unitAssessmentState.openEditor();
  }, [slide]);

  const setCurrentSlide = useCallback(() => {
    unitAssessmentState.setCurrentSlide(slide);
  }, [slide]);

  return (
    <Stack spacing={6}>
      <Box w="full">
        <Box borderWidth="1px" borderRadius="md" p={4} mt={4}>
          {sections.length > 0 && (
            <FormSectionAccordion
              sections={sections}
              slide={slide}
              setCurrentSlide={setCurrentSlide}
            />
          )}
          <Flex justifyContent="center" w="full" pt={4}>
            <Button
              leftIcon={<AddIcon boxSize="16px" />}
              variant="ghost"
              borderWidth={2}
              borderColor="colors.borderEmphasis"
              borderStyle="dashed"
              size="md"
              py="22px"
              w="full"
              onClick={handleAddSection}
            >
              <Trans>Add Form Section</Trans>
            </Button>
          </Flex>
        </Box>
      </Box>
    </Stack>
  );
}
